'use client';

import { SliderWithVideo } from '@sapientpro/sapientpro-data-models';
import Slider from '../Slider/Slider';
import VideoCard from './VideoCard';

const VideoCardSlider = ({ items }: { items: SliderWithVideo['items'] }) => (
  <Slider
    options={{
      slideFocus: 0,
      slideStart: 0,
      slidesPerPage: 1,
      showOverflow: true,
      showPagination: true,
      showArrows: true,
    }}
    slides={items.map((item, index) => ({
      id: item.title,
      content: (
        <VideoCard
          stepNumber={index + 1}
          title={item.title}
          description={item.description}
          video={{
            title: item.title,
            clip: item.video,
            preview: {
              url: item?.previewImage?.url || '',
              alternativeText: item?.previewImage?.alternativeText || 'Process card video preview',
            },
          }}
        />),
    }))}
  />
);

export default VideoCardSlider;
